//@flow
import React from 'react';
import { createPortal } from 'react-dom';
import styles from './AppSpinner.less';
import AKSpinner from '@atlaskit/spinner';

export default function AppSpinner() {
	return createPortal(
		<div className={styles.spinnerWrapper}>
			<AKSpinner size="xlarge" />
		</div>,
		document.getElementById('app-container'),
	);
}
